// extracted by mini-css-extract-plugin
export default {"section":"AGs_section__2PW4z","text":"AGs_text__Wpt7W"};